import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule
  ]
})
export class CommentsComponent implements OnInit, OnDestroy {

  @Output()
  commentsEvent = new EventEmitter<string>();
  commentsForm: UntypedFormGroup;

  subscription = new Subscription();

  constructor(fb: UntypedFormBuilder) {
    this.commentsForm = fb.group({
      commentsControl: fb.control(''),
    });
  }

  ngOnInit(): void {
    this.subscription.add(this.commentsForm.controls.commentsControl.valueChanges
      .pipe(
        debounceTime(500),
      )
      .subscribe((updated: string) =>
        this.commentsEvent.emit(updated)));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @Input()
  set comments(comments: string) {
    if (this.commentsForm.controls.commentsControl.value !== comments) {
      this.commentsForm.controls.commentsControl.setValue(comments);
    }
  }

}
